const CreatorEcommerce = () => <div>Creator Ecommerce</div>;
export default CreatorEcommerce;